import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function ProtectedRoute({ Component, LoginComponent }) {
  // Pobranie accessToken i userRole z Redux
  const accessToken = useSelector((state) => state.tokens.accessToken);
  const userRoles = useSelector((state) => state.tokens.userRoles || []);

  // Lokalny stan do wymuszenia renderowania
  const [isAuthorized, setIsAuthorized] = useState(
    accessToken !== '' && userRoles.includes('EVENT_ADMIN')
  );

  useEffect(() => {
    // Aktualizacja stanu, gdy accessToken lub userRole się zmienia
    setIsAuthorized(accessToken !== '' && userRoles.includes('EVENT_ADMIN'));
  }, [accessToken, userRoles]);

  return isAuthorized ? <Component /> : <LoginComponent />;
}

export default ProtectedRoute;
